import { Container, Grid } from "@material-ui/core";
import Menu from "../../Components/Menu";
import styled from '@emotion/styled'
import Background from "../../img/S1_background.png"

const S1_Header = () => {
    const MainDiv = styled.div`
    // background-image: url(${Background});
    // background-size: cover;
    // background-repeat: no-repeat;
    // background-position-y: bottom;
    min-height: calc(100vh - 16px);
    `
    const Span = styled.span`
    color:#ffffff;
    font-size: 44px;
    text-transform: uppercase;
    font-weight: 600;
    @media screen and (max-width:600px){
      font-size: 30px;
    }
    `

    const BackgroundDiv = styled(Grid)`
    background-image: url(${Background});
    background-size: contain;
    background-repeat: no-repeat;
    /* background-position-y: bottom; */
    /* display: grid; */
    -webkit-alignItems: center;
    -ms-flex-item-alignItems: center;
    alignItems: center;
    min-height: calc(100vh - 290px);
    background-position-x: center;
    background-position-y: center;
    `
  return (
    <MainDiv className="pt-3" id="Home">
      <Menu />
      <Container>
        <BackgroundDiv
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className=""
        >
          <Grid xs={12} sm={12} md={12} className="text-center" style={{position: 'absolute', bottom: 0}}>
            <h1 className="fontweight py-5 mb-5">
                <Span>
                 A solutions driven company
                </Span>
            </h1>
          </Grid>
        </BackgroundDiv>
      </Container>
    </MainDiv>
  );
};

export default S1_Header;
